<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
        type?: "icon" | "text-horizontal" | "text-vertical" | "text";
        grayscale?: boolean;
        extension?: "png" | "svg";
    }>(),
    {
        type: "text-horizontal",
        grayscale: false,
        extension: "svg",
    },
);

const src = computed(() => {
    let variant;

    if (props.type === "icon") {
        variant = props.grayscale ? "logo_gray" : "logo_color";
    } else if (props.type === "text-horizontal") {
        variant = props.grayscale
            ? "logo_text_gray_horizontal"
            : "logo_text_color_horizontal";
    } else if (props.type === "text-vertical") {
        variant = props.grayscale
            ? "logo_text_gray_vertical"
            : "logo_text_color_vertical";
    } else {
        variant = "text_gray";
    }

    return `/assets/logo/${props.extension}/${variant}.${props.extension}`;
});
</script>

<template>
    <nuxt-img :src="src" alt="HireData" />
</template>
